<div class="supp-selector-div">

  @if (params?.context?.isStockManager || !params?.data?._tags?.includes('disabled')) {
    <input
      #input
      (focus)="clearInput()"
      (input)="onSearchInput($event)"
      (keydown.enter)="onEnterKey($event)"
      (keydown.tab)="onTabKey($event)"
      [formControl]="searchControl"
      class="input"
      placeholder="Search Suppliers..."/>
  }

  <select
    (change)="onSelectionChange($event)"
    [ngModel]="getSelectDisplayCode()"
    [disabled]="params?.data?._tags?.includes('disabled') && !params?.context?.isStockManager"
    class="select-supp-list">
    <option value="">{{ blankSupplierLabel }}</option>
    @if (filteredOptions?.length === 0) {
      <option disabled>No matching suppliers</option>
    }
    @for (option of filteredOptions; track option.key) {
      <option [value]="option.key">
        {{ option.key }} - {{ option.description }}
      </option>
    }
  </select>

  <div class="cell-action-icons">
    @if (hasSupplierChanged()) {
      <app-display-icon
        (mousedown)="onIconPointerDown($event)"
        (click)="onUndoChangesClick()"
        [icon]="icons.backSpaceOutline"
        class="backspace"
        [tooltip]="'Undo supplier change'">
      </app-display-icon>
    }
    @if (hasSupplierValue()) {
      <app-display-icon
        (mousedown)="onClearSupplierPointerDown($event)"
        (click)="onClearSupplierClick($event)"
        [icon]="icons.deleteOutline"
        class="delete-supplier"
        [tooltip]="'Clear supplier'">
      </app-display-icon>
    }
  </div>

</div>
